import React from 'react'
import { initializeApollo } from '@gql/client'
import {
  PaginaDocument,
  RivenditoriDocument,
  ProvinceDocument,
  CittaDocument,
  CittaSingolareDocument,
} from '@gql/graphql'
import { NextWrapper } from 'data-fetching-wrapper'
import { RivenditoriTemplate } from '@components/templates'

const RivenditoriPage = ({ pagina, rivenditori, citta, localita }) => (
  <RivenditoriTemplate
    pagina={pagina}
    rivenditori={rivenditori}
    items={citta}
    localita={localita}
    variant="citta"
  />
)

export const getStaticPaths = NextWrapper.getStaticPaths(async ({ locales }) => {
  let paths = []

  return {
    paths: paths,
    fallback: 'blocking',
  }
}, '/rivenditori/[slug_regione]/[slug_provincia]/[slug_citta]')

export const getStaticProps = NextWrapper.getStaticProps(
  async ({
    params: { slug_regione, slug_provincia, slug_citta },
    locale,
    preview,
    previewData,
  }) => {
    const client = initializeApollo(locale)

    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const {
      data: { pagina },
    } = await client.query({
      query: PaginaDocument,
      variables: { chiave: 'rivenditori', preview },
      context: {
        headers,
      },
    })

    if (!pagina) {
      return {
        notFound: true,
      }
    }

    const {
      data: { rivenditori },
    } = await client.query({
      query: RivenditoriDocument,
      variables: {
        citta: slug_citta,
      },
    })

    if (!rivenditori || rivenditori.length == 0) {
      return {
        notFound: true,
      }
    }

    const {
      data: { citta },
    } = await client.query({
      query: CittaDocument,
      variables: {
        provincia: slug_provincia,
      },
    })

    const {
      data: { cittaSingolare: localita },
    } = await client.query({
      query: CittaSingolareDocument,
      variables: {
        slug: slug_citta,
      },
    })

    return {
      props: { pagina, rivenditori, citta, localita },
      revalidate: 60 * 20,
    }
  },
  '/rivenditori/[slug_regione]/[slug_provincia]/[slug_citta]'
)

export default RivenditoriPage
